/* eslint-disable no-useless-constructor */
import React, { useRef, useMemo, Fragment } from 'react'
import { withTranslation } from 'react-i18next'
import ContactInformation from './ContactInformation'
import styles from './Confirmation.module.scss'
import PrintComponent from './PrintComponent'
import SaveCopy from './SaveCopy'
import { useSelector } from 'react-redux'
import * as moment from 'moment'

export const PrintContent1 = ({ t, i18n, emailAddress, paymentTransactionNum, transId, transOwner }) => {
  const getRenewVehiclePermitPrivacyUrl = () => {
    const origin = window.location.origin
    if (origin.includes('dev-renewvehiclepermit.ds4u.novascotia.dev')) {
      return i18n.language === 'en'
        ? 'https://dev-renewvehiclepermit.ds4u.novascotia.dev/en/fines-question'
        : 'https://dev-renewvehiclepermit.ds4u.novascotia.dev/fr/amendes-verification'
    } else if (origin.includes('test-renewvehiclepermit.ds4u.novascotia.dev')) {
      return i18n.language === 'en'
        ? 'https://test-renewvehiclepermit.ds4u.novascotia.dev/en/fines-question'
        : 'https://test-renewvehiclepermit.ds4u.novascotia.dev/fr/amendes-verification'
    } else if (origin.includes('uat-renewvehiclepermit.ds4u.novascotia.dev')) {
      return i18n.language === 'en'
        ? 'https://uat-renewvehiclepermit.ds4u.novascotia.dev/en/fines-question'
        : 'https://uat-renewvehiclepermit.ds4u.novascotia.dev/fr/amendes-verification'
    } else {
      return i18n.language === 'en'
        ? 'https://renewvehiclepermit.novascotia.ca/en/fines-question'
        : 'https://renewvehiclepermit.novascotia.ca/fr/amendes-verification'
    }
  }

  const renewVehiclePermitPrivacyUrl = getRenewVehiclePermitPrivacyUrl()

  const handleGoBackToStart = (e) => {
    e.preventDefault()
    const url = getRenewVehiclePermitPrivacyUrl()
    window.location.replace(url)
  }

  return (
    <div className={'container'}>
      <div style={{ display: 'flex', marginLeft: '-80px' }}>
        <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', marginTop: '30px' }}>
          <div className={'col-xs-1 ' + styles['success_margin_right']}>
            <i className="fa fa-check-circle fa-2x" aria-hidden="true"></i>
          </div>
          <div style={{ flexGrow: 1, backgroundColor: 'green', width: '5px' }} />
        </div>

        <div style={{ flexGrow: 1 }}>
          <div className="col-xs-12 col-lg-8">
            <div className="row">
              <div className="col-xs-12">
                <h1 style={{ color: 'green' }}>{t('receive_confirmation.your_permit_renewed')}</h1>
              </div>
            </div>
            <div className="row">
              <div className="col-xs-12 col-lg-8" style={{ marginTop: '-20px' }}>
                <h2>
                  {t('receive_confirmation.your_transaction_number')} <strong>{paymentTransactionNum}</strong>
                </h2>
              </div>
            </div>
            <div className="row">
              <div className="col-xs-12" style={{ marginTop: '-20px' }}>
                <h3>{t('receive_confirmation.we_have_emailed')} </h3>
              </div>
            </div>
            <div className="row">
              <div className="col-xs-12" style={{ marginTop: '-10px' }}>
                <h4>{t('receive_confirmation.print_or_save')}</h4>
              </div>
            </div>
            <div className="print_no_display col-lg-8">
              <div className="row">
                <div style={{ display: 'flex', flexGrow: 1, marginTop: '30px' }}>
                  <div className={styles['display_flex']}>
                    <div className={styles['back_center']}>
                      {typeof InstallTrigger !== 'undefined' || /*@cc_on!@*/ false || !!document.documentMode ? null : (
                        <PrintComponent transId={transId} transOwner={transOwner} />
                      )}
                      <SaveCopy transId={transId} transOwner={transOwner} />
                    </div>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-xs-12">
                  <a href={renewVehiclePermitPrivacyUrl} className={styles['all_finished_link']} onClick={handleGoBackToStart}>
                    {t('receive_confirmation.all_finished')}
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

const GetVehicleTable = ({ vehicleData, t, permits }) => {
  return (
    <table className="table table-bordered">
      <thead>
        <tr>
          <th>{t('receive_confirmation.vin_number')}</th>
          <th>{t('receive_confirmation.make')}</th>
          <th>{t('receive_confirmation.year')}</th>
          <th>{t('receive_confirmation.weight')}</th>
          <th>{t('receive_confirmation.plate_number')}</th>
        </tr>
      </thead>
      <tbody>
        {permits.map((permit, i) => {
          const vehicle = vehicleData[permit.plateNumber]
          if (!vehicle) {
            return null
          }
          return (
            <tr key={i}>
              <td>{vehicle.vin}</td>
              <td>{vehicle.vehicleMake}</td>
              <td>{vehicle.year}</td>
              <td>{vehicle.weight}</td>
              <td>{vehicle.plateNumber}</td>
            </tr>
          )
        })}
      </tbody>
    </table>
  )
}

const ReceiveConfirmationView = ({ t, i18n, setIsError }) => {
  const pageElem = useRef()

  const { transId, emailAddress, transOwner, transNum } = useSelector((state) => state.confirmation)

  const getPhoneNumber = (text) => {
    return `tel:${t(text)}`
  }

  const permits = useSelector((state) => state.app.permits)
  const vehicleData = useSelector((state) => state.vehicleDataAPI.vehicleData)
  const { fullName, masterNumber } = useSelector((state) => state.app)

  const dateUntil = useMemo(() => {
    const date = new Date()
    date.setDate(date.getDate() + 30)
    return moment(date).locale(i18n.language).format('DD MMM YYYY')
  }, [i18n.language])

  const displayFullName = useMemo(() => {
    const words = fullName.split(' ')
    return (
      words &&
      words
        .map((word) => {
          return word !== undefined && word[0]?.toUpperCase() + word?.substring(1)
        })
        .join(' ')
    )
  }, [fullName])

  return (
    <Fragment>
      <div ref={pageElem}>
        <div className="container">
          <div className="print_no_display">
            <PrintContent1
              i18n={i18n}
              t={t}
              emailAddress={emailAddress}
              paymentTransactionNum={transNum}
              transId={transId}
              transOwner={transOwner}
            />
            <div className="row">
              <div className="col-xs-12 col-lg-8">
                <h2>{t('receive_confirmation.what_happens_next')}</h2>
                <div className="row">
                  <div className="col-xs-12">
                    <p>
                      <strong>{t('receive_confirmation.confirmation_email')}</strong>
                      <br />
                      {t('receive_confirmation.confirmation_email_info')} <strong>{emailAddress}</strong>
                      <br />
                      {t('receive_confirmation.confirmation_email_info_continued')}
                    </p>
                  </div>
                </div>
                <div className="row">
                  <div className="col-xs-12">
                    <p>
                      <strong>{t('receive_confirmation.payment_processed')}</strong>
                      <br />
                      {t('receive_confirmation.payment_processed_info')}
                    </p>
                  </div>
                </div>
                <div className="row">
                  <div className="col-xs-12">
                    <p>
                      <strong>{t('receive_confirmation.interim_permit')}</strong>
                      <br />
                      {t('receive_confirmation.interim_permit_info')}
                    </p>
                  </div>
                </div>
                <div className="row">
                  <div className="col-xs-12">
                    <p>
                      {t('receive_confirmation.if_you_dont')} {t('receive_confirmation.contact_us_at')}
                    </p>
                  </div>
                </div>
                <h2 style={{ marginTop: '0px' }}>{t('review_confirmation.plate_owner_information')}</h2>
                <div className="row row-odd">
                  <div className="col-xs-6">
                    <strong>{t('receive_confirmation.plate_owner')}</strong>
                  </div>
                  <div className="col-xs-6">{displayFullName}</div>
                </div>
                <div className="row row-even">
                  <div className="col-xs-6">
                    <strong>{t('receive_confirmation.owner_master')}</strong>
                  </div>
                  <div className="col-xs-6">{masterNumber}</div>
                </div>
                <div className="row row-odd">
                  <div className="col-xs-6">
                    <strong>{t('receive_confirmation.interim_permit_effective')}</strong>
                  </div>
                  <div className="col-xs-6">{dateUntil}</div>
                </div>
                {permits.map((permit) => {
                  const vehicle = vehicleData[permit.plateNumber]
                  if (!vehicle) {
                    return null
                  }
                  const vinNumber = (
                    <Fragment>
                      <div className="col-xs-6">
                        <strong>{t('receive_confirmation.vin_number')}</strong>
                      </div>
                      <div className="col-xs-6">{vehicle.vin}</div>
                    </Fragment>
                  )
                  const vehicleMake = (
                    <Fragment>
                      <div className="col-xs-6">
                        <strong>{t('receive_confirmation.make')}</strong>
                      </div>
                      <div className="col-xs-6">{vehicle.vehicleMake}</div>
                    </Fragment>
                  )
                  const vehicleYear = (
                    <Fragment>
                      <div className="col-xs-6">
                        <strong>{t('receive_confirmation.year')}</strong>
                      </div>
                      <div className="col-xs-6">{vehicle.year}</div>
                    </Fragment>
                  )
                  const vehicleWeight = (
                    <Fragment>
                      <div className="col-xs-6">
                        <strong>{t('receive_confirmation.weight')}</strong>
                      </div>
                      <div className="col-xs-6">{vehicle.weight}</div>
                    </Fragment>
                  )
                  const vehiclePlateNumber = (
                    <Fragment>
                      <div className="col-xs-6">
                        <strong>{t('receive_confirmation.plate_number')}</strong>
                      </div>
                      <div className="col-xs-6">{vehicle.plateNumber}</div>
                    </Fragment>
                  )
                  return (
                    <Fragment>
                      <h2>{t('review_confirmation.plate_renewal_info')}</h2>
                      <Fragment>
                        <div className="row row-odd">{vinNumber}</div>
                        <div className="row row-even">{vehicleMake}</div>
                        <div className="row row-odd">{vehicleYear}</div>
                        <div className="row row-even">{vehicleWeight}</div>
                        <div className="row row-odd">{vehiclePlateNumber}</div>
                      </Fragment>
                    </Fragment>
                  )
                })}
                <br />
                {/* <div className="row">
                  <div className="col-xs-12 col-lg-10">
                    <GetVehicleTable vehicleData={vehicleData} permits={permits} t={t} />
                  </div>
                </div> */}

                <div className="row">
                  <div className="col-xs-12">
                    <p>{t('receive_confirmation.note_your_new')}</p>
                    <h2>{t('receive_confirmation.if_you_have_questions')}</h2>
                    <p>{t('receive_confirmation.if_you_have_questions_info')}</p>
                  </div>
                </div>
                <ContactInformation />
              </div>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  )
}

export default withTranslation('common')(ReceiveConfirmationView)
